export const ActionTypes = {
  SHOW_TRIAL_EXPIRED_DIALOG: 'SHOW_TRIAL_EXPIRED_DIALOG',
  HIDE_TRIAL_EXPIRED_DIALOG: 'HIDE_TRIAL_EXPIRED_DIALOG',
}

export const showTrialExpiredDialogAction = () => ({
  type: ActionTypes.SHOW_TRIAL_EXPIRED_DIALOG,
})

export const hideTrialExpiredDialogAction = () => ({
  type: ActionTypes.HIDE_TRIAL_EXPIRED_DIALOG,
})
